// Status metadata for Locations > location > Shifts. The server decides each
// row's status (ShiftStatus); this only labels, colours and filters them.
export const STATUSES = [
  { key: 'in_progress', label: 'In Progress', color: 'green', textColor: 'white', defaultOn: true },
  { key: 'upcoming', label: 'Upcoming', color: 'blue', textColor: 'white', defaultOn: true },
  { key: 'completed', label: 'Completed', color: 'grey', textColor: 'white', defaultOn: true },
  { key: 'cc_pending', label: 'CC Pending', color: 'orange', textColor: 'white', defaultOn: true },
  { key: 'cancelled', label: 'Cancelled', color: 'red', textColor: 'white', defaultOn: false },
  { key: 'sunset', label: 'Sunset', color: 'red', textColor: 'white', defaultOn: false },
  { key: 'absent', label: 'Absent', color: 'purple', textColor: 'white', defaultOn: true },
  { key: 'unfilled', label: 'Unfilled', color: 'black', textColor: 'white', defaultOn: false },
]

export function defaultSelectedKeys () {
  return STATUSES.filter(s => s.defaultOn).map(s => s.key)
}

export function statusMeta (key) {
  return STATUSES.find(s => s.key === key) || null
}

// Rows with no status (unapproved, trade pending) are always shown (Lanie).
export function filterRows (rows, selectedKeys) {
  return rows.filter(row => row.status == null || selectedKeys.includes(row.status))
}
